interface InfoIconProps {
    className?: string;
  }
  
  const InfoIcon = ({ className }: InfoIconProps) => {
    return (
      <div
        className={`bg-bg-header rounded-full h-[24px] p-[2px] w-[24px] mr-[8px] flex items-center justify-center ${className}`}
      >
        <span className="material-symbols-outlined text-[16px] text-text-base">
          info
        </span>
      </div>
    );
  };
  
  export default InfoIcon;
  